import React from 'react';

const UserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 1C14.96 1 19 5.04 19 10C19 11.42 18.66 12.76 18.07 13.96C16.54 12.24 14.09 11.07 10.69 10.93C12.57 10.6 14 8.97 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 8.97 7.43 10.6 9.31 10.93C5.91 11.07 3.46 12.24 1.93 13.96C1.34 12.76 1 11.42 1 10C1 5.04 5.04 1 10 1ZM7 7C7 5.35 8.35 4 10 4C11.65 4 13 5.35 13 7C13 8.65 11.65 10 10 10C8.35 10 7 8.65 7 7ZM10 19C6.84 19 4.06 17.36 2.45 14.88C4.01 12.93 6.61 11.9 10 11.9C13.39 11.9 15.99 12.93 17.55 14.88C15.94 17.36 13.16 19 10 19Z"
        fill="#065FD4"
      />
    </svg>
  );
};

export default UserIcon;
